export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13873.e5201855.jpg";